@if (vm.showPenalties && !isNewEDPScoreboard) {
    <div class="penalty-shootout-container">
        <div class="penalty-shootout-score">
            <ms-event-timer class="penalty-shootout-text" [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
            <div class="penalty-score">
                <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[0]" />
                <div class="event-score">
                    <ms-score-card
                        [eventId]="event.id"
                        [participant1Score]="vm.penalties[0].points.toString()"
                        [participant2Score]="vm.penalties[1].points.toString()" />
                </div>
                <ms-penalty-shootout class="penalty-shootout" [penalties]="vm.penalties[1]" />
            </div>
        </div>
    </div>
}
@if (isNewEDPScoreboard) {
    <div class="bases-containers">
        @for (i of [0, 1]; track i) {
            <vn-icon width="12" height="14" class="sports-sb-icons" [name]="vm.icon ?? ''" [ngClass]="{ invisibility: inVisibility(i) }" />
        }
    </div>
}
@if (((vm.showPenalties || !vm.showPenalties) && isNewEDPScoreboard) || (!vm.showPenalties && !isNewEDPScoreboard)) {
    <div class="period-score">
        @if (!isNewEDPScoreboard) {
            <div class="participant-header-info">
                <div class="live-participants-container">
                    <div class="period-game-participant-info" *ngFor="let participant of event.participants; let i = index">
                        <ms-scoreboard-participant
                            class="participant-info"
                            [showIndicator]="false"
                            [event]="event"
                            [participant]="event.participants[i]" />
                    </div>
                </div>
            </div>
        }

        <div class="inning-block">
            <div>
                <div class="innings innings-header">
                    <div
                        class="set inning-info"
                        *ngFor="let period of vm.score.participant1.periods; let index = index"
                        [ngClass]="{ highlightedscore: period.current }">
                        {{ index + 1 }}
                    </div>
                    @if (vm.showOvertime) {
                        <div class="set inning-info" [ngClass]="{ highlightedscore: vm.showOvertime }">
                            {{ sitecoreEventDetails.eventDetails.ShortOvertime }}
                        </div>
                    }
                </div>
                @if (!isNewEDPScoreboard) {
                    <div class="slidebar"></div>
                }
                <div class="innings" *ngFor="let periodScore of vm.periodScore">
                    <div class="set" *ngFor="let period of periodScore.periods; let index = index" [ngClass]="{ highlighted: period.current }">
                        {{ period.points }}
                    </div>
                    @if (vm.showOvertime) {
                        <div class="set" [ngClass]="{ highlightedscore: vm.showOvertime }">
                            {{ periodScore.overTimeScore }}
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
@if (isNewEDPScoreboard) {
    <div class="score-container" [ngClass]="{ inactive: vm.isSuspended }">
        <ms-score-card
            [eventId]="event.id"
            [participant1Score]="vm.score.participant1.total.toString()"
            [participant2Score]="vm.score.participant2.total.toString()"
            [showSeparator]="!isNewEDPScoreboard" />
    </div>
}
